import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

import {Constants} from '../config/constants.config';
import {Country} from '../models/country.model';
import {map} from 'rxjs/operators';

@Injectable()
export class CountriesService {

    constructor(
        private readonly httpClient: HttpClient,
        private readonly constants: Constants
    ) {
    }

    getCountries(): Observable<Country[]> {
        return this.httpClient.get(`${this.constants.apiURL()}/user/countries`).pipe(
            map(response => {
                const keys: string[] = Object.keys(response);

                return keys.map(k => {
                    return new Country(k, response[k]);
                });
            })
        );
    }
}
